import { Component, Input, OnInit, ChangeDetectorRef } from '@angular/core';
import { LossCodesService } from './loss-codes.service';
import { buttonStatus } from '../../shared/constants/button-class';
import { Popover } from 'primeng/popover';
import { toggleEllipsisPopover } from 'src/app/modules/crm/shared/utilities/ellipsis-popover.util';
import { ellipsisOptions, ellipsisHeaderOptions } from '../../shared/constants/ellipsis-options';
import { KeyMap } from '../../shared/interface/key-map.interface';
import { v4 as uuidv4 } from 'uuid';
import { ConfirmationService } from 'primeng/api';
import { LossCode } from '../coverage-models';
import { copy } from '../../shared/utilities/common-utilities';
@Component({
  standalone: false,
  selector: 'cv-loss-codes',
  templateUrl: 'loss-codes.template.html',
  providers: [LossCodesService],
})
export class LossCodesComponent implements OnInit {
  dataList: any[];
  cols: any[];
  btnStatus: any = buttonStatus;
  selectedItem: any;
  ellipsisOptions: any[] = ellipsisOptions;
  ellipsisHeaderOptions: any[] = copy(ellipsisHeaderOptions);
  selectedEllipsisItem: any;
  clonedRowData: KeyMap = {};
  isEditing: boolean;
  editConstant: string;
  selectedRowIndex: number;
  constructor(
    private lossCodesService: LossCodesService,
    private confirmationService: ConfirmationService,
    private cdr: ChangeDetectorRef,
  ) {}

  ngOnInit() {
    this.editConstant = uuidv4();
    this.lossCodesService.getLossCodes().subscribe((data) => {
      this.dataList = data;
    });
    this.cols = [
      { field: 'code', header: 'CODE', type: 'text' },
      { field: 'description', header: 'DESCRIPTION', type: 'text' },
      { field: 'type', header: 'TYPE', type: 'text' },
      { field: 'laborHours', header: 'LABOR HOURS', type: 'text' },
      { field: 'partsCost', header: 'PARTS COST', type: 'text' },
    ];
  }

  ellipsisClick(event, item, Popover: Popover, rowIndex) {
    this.selectedItem = item;
    this.selectedRowIndex = rowIndex;
    toggleEllipsisPopover(event, Popover);
  }

  ellipsisOptionClick(event) {
    // ellipsis functionality goes here
  }

  onRowEdit() {
    this.isEditing = true;
    document.getElementById(this.editConstant + this.selectedItem.id).click();
  }

  onRowEditInit(rowData: any) {
    this.clonedRowData[rowData.id] = { ...rowData };
  }
  onRowEditSave(rowData: any) {
    delete this.clonedRowData[rowData.id];
    this.isEditing = false;
  }

  onRowEditCancel(rowData: any, index: number) {
    if (rowData[`isNew`]) {
      this.confirmationService.confirm({
        message: 'Are you sure that you want to discard, these changes?',
        accept: () => {
          this.dataList[index] = this.clonedRowData[rowData.id];
          delete this.clonedRowData[rowData.id];
          this.isEditing = false;
          this.dataList.splice(this.selectedRowIndex, 1);
        },
      });
    } else {
      this.dataList[index] = this.clonedRowData[rowData.id];
      delete this.clonedRowData[rowData.id];
      this.isEditing = false;
    }
  }

  onClickAdd(event) {
    let rowItem = new LossCode();
    rowItem.id = this.dataList.length + 1;
    rowItem[`isNew`] = true;
    rowItem = { ...rowItem };
    this.dataList.push(rowItem);
    this.cdr.detectChanges();
    this.selectedItem = rowItem;
    this.selectedRowIndex = this.dataList.length - 1;
    this.onRowEdit();
  }

  onRowDelete(event, Popover: Popover) {
    Popover.hide();
    this.confirmationService.confirm({
      message: 'Are you sure that you want to delete this row?',
      accept: () => {
        this.dataList.splice(this.selectedRowIndex, 1);
      },
    });
  }
}
